import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/',
      name: 'index',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('./views/Search.vue')
    },
    {
      path: '/movies',
      name: 'movies',
      component: () => import('./views/MoviesList.vue')
    },
    {
      path: '/tv-shows',
      name: 'tv-shows',
      component: () => import('./views/TvShowsList.vue')
    },
    {
      path: '/live-tv',
      name: 'live-tv',
      component: () => import('./views/Live.vue'),
      redirect: { name: 'live.home' },
    },
    {
      path: '/movie/:id',
      name: 'movie',
      component: () => import('./views/Movie.vue'),
    },
    {
      path: '/movie/:id/play',
      name: 'movie.play',
      component: () => import('./views/MoviePlay.vue')
    },
    {
      path: '/tv-show/:id',
      name: 'tv-show',
      component: () => import('./views/TvShow.vue'),
    },
    {
      path: '/tv-show/:id/play',
      name: 'tv-show.play',
      component: () => import('./views/TvShowPlay.vue')
    },
    {
      path: '/genre/',
      name: 'genre.index',
    },
    {
      path: '/genre/:genre',
      name: 'genre',
      component: () => import('./views/Genre.vue'),
    },
    {
      path: '/category/',
      name: 'category.index',
    },
    {
      path: '/category/:category',
      name: 'category',
      component: () => import('./views/Category.vue'),
    },
    {
      path: '/discover',
      name: 'discover',
      component: () => import('./views/discover/Discover.vue'),
      redirect: '/discover/movies',
      children: [
        {
          path: 'movies',
          name: 'discover.movies',
          component: () => import('./views/discover/MovieDiscover.vue')
        },
        {
          path: 'tv-shows',
          name: 'discover.shows',
          component: () => import('./views/discover/TvShowDiscover.vue')
        }
      ]
    },
    {
      path: '/live',
      name: 'live',
      component: () => import('./views/live/LiveIndex.vue'),
      redirect: { name: 'live.home' },
      children: [
        {
          path: 'home',
          redirect: { name: 'live.home'},
        },
        {
          path: '',
          name: 'live.home',
          component: () => import('./views/live/v2/LiveHome.vue'),
          redirect: { name: 'live.home.list', params: {category: 'ALL'} },
          children: [
            {
              name: 'live.home.list',
              path: ':category',
              component: () => import('./views/live/v2/LiveHomeList.vue')
            }
          ],
        },
        {
          path: ':category/:id',
          name: 'live.v2.stream',
          component: () => import('./views/live/v2/Stream.vue')
        },
        {
          path: 'stream/:id',
          name: 'live.stream',
          component: () => import('./views/live/Stream.vue')
        },
        // {
        //   path: 'search',
        //   name: 'live.search',
        //   component: () => import('./views/live/Search.vue')
        // },
      ]
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/Profile.vue'),
      redirect: {
        name: 'profile.edit'
      },
      children: [
        {
          name: 'profile.menu-list',
          path: 'menu',
          component: () => import('./views/profile/MenuList.vue')
        },
        {
          name: 'profile.edit',
          path: 'edit',
          component: () => import('./views/profile/Edit.vue')
        },
        {
          name: 'profile.change_password',
          path: 'change-password',
          component: () => import('./views/profile/ChangePassword.vue')
        },
        {
          name: 'profile.invite',
          path: 'invite',
          component: () => import('./views/profile/Invite.vue')
        },
        {
          name: 'profile.site_settings',
          path: 'site-settings',
          component: () => import('./views/profile/SiteSettings.vue')
        },
        {
          name: 'profile.player_settings',
          path: 'player-settings',
          component: () => import('./views/profile/PlayerSettings.vue')
        },
        {
          name: 'profile.admin_request',
          path: 'admin-request',
          component: () => import('./views/profile/AdminRequest.vue')
        },
      ]
    },
  ]
})
